import PlaneIcon from '../../../assets/icons/flights/plane-up.svg';
import ShopIcon from '../../../assets/icons/poi/shop.svg';
import MagnifierIcon from '../../../assets/icons/unified-search/magnifier.svg';

import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';

const NO_RESULTS_MESSAGE =
	'There are no results for your search, please change your search input.';

enum NoResultsType {
	Generic,
	Flights,
	Locations,
	Information,
}

export function getNoResultsData(
	filterFlights: boolean,
	filterLocations: boolean,
	filterInformation: boolean,
) {
	const noResultsType = getNoResultsType(
		filterFlights,
		filterLocations,
		filterInformation,
	);

	switch (noResultsType) {
		case NoResultsType.Flights:
			return {
				title: 'No flights found',
				message: NO_RESULTS_MESSAGE,
				icon: <PlaneIcon />,
				link: {
					url: PageRoutes.Flights,
					urlText: 'Go to flight page',
				},
			};
		case NoResultsType.Locations:
			return {
				title: 'No results',
				message: NO_RESULTS_MESSAGE,
				icon: <ShopIcon />,
				link: {
					url: PageRoutes.ShopDineRelax,
					urlText: 'Go to Shop & Dine',
				},
			};
		case NoResultsType.Information:
			return {
				title: 'No information found',
				message: NO_RESULTS_MESSAGE,
				icon: <MagnifierIcon />,
			};
		default:
			return {
				title: 'No results',
				message: NO_RESULTS_MESSAGE,
				icon: <MagnifierIcon />,
			};
	}
}

function getNoResultsType(
	filterFlights: boolean,
	filterLocations: boolean,
	filterInformation: boolean,
) {
	if (filterFlights && !filterLocations && !filterInformation)
		return NoResultsType.Flights;
	if (!filterFlights && filterLocations && !filterInformation)
		return NoResultsType.Locations;
	if (!filterFlights && !filterLocations && filterInformation)
		return NoResultsType.Information;
	return NoResultsType.Generic;
}
